module.exports = __webpack_public_path__ + "7022e00ac80fd2175e25b669318e7223.jpg";